// extracted by mini-css-extract-plugin
module.exports = {"roleCode":"sp-readiness-rules-table_roleCode__2a5O5","textField":"sp-readiness-rules-table_textField__2yati"};